module.exports = __webpack_public_path__ + "static/img/header-login.3051d4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/header-login.png
// module id = ZAvn
// module chunks = 0